var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgR(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M201.327 287.648C267.509 282.621 319.999 227.762 319.999 160.313C319.999 89.562 262.436 32 191.687 32H8C3.578 32 0 35.594 0 40V472C0 476.406 3.578 480 8 480S16 476.406 16 472V288.625H184.595C184.7 289.906 184.546 291.219 185.296 292.375L305.296 476.375C306.827 478.719 309.389 480 311.999 480C313.499 480 315.014 479.594 316.374 478.688C320.077 476.281 321.108 471.344 318.702 467.625L201.327 287.648ZM16 48H191.687C253.608 48 303.999 98.375 303.999 160.312S253.608 272.625 191.687 272.625H16V48Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgR);
export default __webpack_public_path__ + "static/media/r.078031d3acf58a5a518fe406bc04e7cc.svg";
export { ForwardRef as ReactComponent };